import { Notification, NotificationStatus } from '@cp-shared-10/frontend-ui';
import { useTranslation } from 'react-i18next';
import React from 'react';

export const RequestCertificateInfoBox: React.FC = () => {
    const { t } = useTranslation('request-certificate');
    return <Notification status={NotificationStatus.info} headline={t('info.headline')} text={t('info.text')} />;
};
